import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { onlineManager } from 'react-query';
import { useNotification } from 'src/contexts/NotificationContext';

export function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const { showSuccess, showWarning } = useNotification();
  const { t } = useTranslation();

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      onlineManager.setOnline(true);
      showSuccess({ message: t('global.network.back_online') });
    };

    const handleOffline = () => {
      setIsOnline(false);
      onlineManager.setOnline(false);
      showWarning({
        message: t('global.network.offline_mode'),
        autoClose: 5000,
      });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [showSuccess, showWarning, t]);

  return isOnline;
}
